import {
  getCardsProductsList,
  type CardProduct,
} from 'api/v2/connectors/getCardsProductsList';
import useQuery from 'hooks/react-query/useQuery';
import { type UseQueryResult } from '@tanstack/react-query';
import { CardsProductsCacheKeys } from 'types/cacheKeys.types';

const useGetCardsProductsList = (): UseQueryResult<CardProduct[], unknown> => {
  return useQuery([CardsProductsCacheKeys.Cards], () => getCardsProductsList());
};

export default useGetCardsProductsList;
